<template>
	<div style="min-width: 800px">
		<div class="set_indexBox">
			<div class="set_tit">Setting</div>
			<div class="setting_optionsBox" @click="jump('/version')">
				<span class="options_msg">Version</span>
                <i class="el-icon-arrow-right myset_icon"></i>
			</div>
            
            <div v-if="isEnableDiscount" class="setting_optionsBox" @click="jump('/discount')">
				<span class="options_msg">Discount</span>
                <i class="el-icon-arrow-right myset_icon"></i>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
            isEnableDiscount: process.env.IS_ENABLE_DISCOUNT == '1' ? true : false
        }
	},
    methods: {
        jump (path) {
            this.$router.push(path)
        },
    }
}
</script>

<style lang="scss">
.set_indexBox{
    width: 100%;
    .set_tit{
        height:33px;
        font-size:24px;
        font-family:PingFang SC;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:33px;
        -webkit-text-stroke:1px rgba(255,255,255,1);
        text-stroke:1px rgba(255,255,255,1);
        margin-bottom: 39px;
    }
    .setting_optionsBox{
        display: flex;
        align-items: center;
        padding: 0 30px;
        background:#151c27;
        height: 70px;
        margin-bottom: 30px ;
        cursor: pointer;
        .options_msg{
            height:28px;
            font-size:20px;
            font-family:PingFang SC;
            font-weight:600;
            color:rgba(255,255,255,1);
            line-height:28px;
        }
        .optionsItem_msg{
            margin-left: auto;
            margin-right: 15px;
            font-size: 16px;
            font-weight: 400;
            color: #D4D6D9;
        }
        .myset_icon{
            margin-left: auto;
            font-size: 22px;
            color: #ffffff;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/setting/index.vue